import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DpUserPurchaseNumberStateService {
  readonly #state$ = new BehaviorSubject<string | undefined>(undefined);

  get state(): string | undefined {
    return this.#state$.getValue();
  }

  get state$(): Observable<string | undefined> {
    return this.#state$.asObservable();
  }

  set state(state: string | undefined) {
    this.#state$.next(state);
  }
}
